/* Interaktion; Designwerte stehen in der gleichnamigen CSS-Datei. */
(() => {
    if (customElements.get('alleycat-header-menu')) return;

    class AlleycatHeaderMenu extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('.alleycat-header-menu__details');
        this.toggleButton = this.querySelector('.alleycat-header-menu__toggle');
        this.duration = Number.parseInt(this.dataset.animationDuration, 10) || 650;

        if (!this.details || !this.toggleButton) return;

        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
        this.handleDisclosureToggle = this.handleDisclosureToggle.bind(this);

        this.toggleButton.addEventListener('click', this.handleToggleClick);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleDocumentKeydown);

        this.disclosures = [...this.querySelectorAll('details')];
        this.disclosures.forEach((disclosure) => {
          disclosure.addEventListener('toggle', this.handleDisclosureToggle);
          this.updateExpandedState(disclosure);
        });
      }

      disconnectedCallback() {
        if (!this.toggleButton) return;

        this.toggleButton.removeEventListener('click', this.handleToggleClick);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        this.disclosures?.forEach((disclosure) => {
          disclosure.removeEventListener('toggle', this.handleDisclosureToggle);
        });
        window.clearTimeout(this.closeTimer);
      }

      updateExpandedState(disclosure) {
        const summary = disclosure.querySelector(':scope > summary');
        summary?.setAttribute('aria-expanded', disclosure.open ? 'true' : 'false');
      }

      handleDisclosureToggle(event) {
        this.updateExpandedState(event.currentTarget);
      }

      handleToggleClick(event) {
        event.preventDefault();

        if (this.details.open && !this.details.classList.contains('is-closing')) {
          this.close();
        } else {
          this.open();
        }
      }

      handleDocumentClick(event) {
        if (!this.details.open || this.contains(event.target)) return;
        this.close();
      }

      handleDocumentKeydown(event) {
        if (event.key !== 'Escape' || !this.details.open) return;

        event.preventDefault();
        this.close(true);
      }

      open() {
        window.clearTimeout(this.closeTimer);
        this.details.classList.remove('is-closing');
        this.details.classList.add('menu-opening');
        this.details.open = true;
        this.updateExpandedState(this.details);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (this.details.open) this.details.classList.add('is-open');
          });
        });
      }

      close(returnFocus = false) {
        if (!this.details.open || this.details.classList.contains('is-closing')) return;

        this.details.classList.remove('is-open');
        this.details.classList.add('is-closing');
        window.clearTimeout(this.closeTimer);

        this.closeTimer = window.setTimeout(() => {
          if (!this.details.classList.contains('is-open')) {
            this.details.open = false;
            this.details.classList.remove('is-closing', 'menu-opening');
            this.disclosures
              .filter((disclosure) => disclosure !== this.details)
              .forEach((disclosure) => {
                disclosure.open = false;
                this.updateExpandedState(disclosure);
              });
            this.updateExpandedState(this.details);
            if (returnFocus) this.toggleButton.focus();
          }
        }, this.duration + 40);
      }
    }

    customElements.define('alleycat-header-menu', AlleycatHeaderMenu);
  })();
